import { useAuth } from "./auth.jsx";

export function useIsPremium() {
  const { user } = useAuth();
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!["active", "trial"].includes(user.subscription_status)) return false;
  if (!user.subscription_expires_at) return user.subscription_status === "active";
  return new Date(user.subscription_expires_at) > new Date();
}
